/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ResponseWrapperOfGetNationalitiesResponse } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class Nationalities<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Nationalities
   * @name NationalitiesGet
   * @summary Get list of supported nationalities. Replaced with /v1/autofill/country
   * @request GET:/v1/nationalities
   * @secure
   */
  nationalitiesGet = (params: RequestParams = {}) =>
    this.http.request<ResponseWrapperOfGetNationalitiesResponse, any>({
      path: `/v1/nationalities`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
}
